export const audios = [
  {
    id: 'alarm_1',
    name: 'Alarm 1',
  },
  {
    id: 'alarm_2',
    name: 'Alarm 2',
  },
  {
    id: 'alarm_3',
    name: 'Alarm 3',
  },
  {
    id: 'alarm_4',
    name: 'Alarm 4',
  },
  {
    id: 'beep',
    name: 'Beep',
  },
  {
    id: 'tic_tac',
    name: 'Tic Tac',
  },
] as const
